module.exports = __webpack_public_path__ + "img/single_phase.2101197a.png";